import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";
import {AgentType} from "../../agents/types/agent.type";

export class AgentConfigurationProfilesRequestsService {

  /* @ngInject */
  constructor(private AgentConfigurationProfilesAPI: BringozApi, private $agentConfigurationProfiles) {
  }

  createAgentProfile(profile) {
    const api = this.AgentConfigurationProfilesAPI.actions.createOne;
    return this.$$call(api, {}, profile, {});
  }

  assignAgentsToProfile(profileId, agentIds) {
    const api = this.AgentConfigurationProfilesAPI.actions.assignConfigurationProfile;
    return this.$$call(api, {agentIds: agentIds}, {}, {profileId: profileId});
  }

  getDefaultProfile(agentTypes: AgentType[]) {
    const api = this.AgentConfigurationProfilesAPI.actions.getDefaultAgentProfile;
    return this.$$call(api, {isDefault: true, agentTypes}, {}, {});
  }

  updateOne(profile) {
    const api = this.AgentConfigurationProfilesAPI.actions.updateOne;
    return this.$$call(api, {}, profile, {id: profile.id});
  }

  deleteOne(profileId) {
    const api = this.AgentConfigurationProfilesAPI.actions.deleteOne;
    return this.$$call(api, {}, {}, {id: profileId});
  }

  getConfigurationByAgent(agentId: string) {
    const api = this.AgentConfigurationProfilesAPI.actions.getConfigurationByAgent;
    return this.$$call(api, {}, {}, {agentId: agentId});
  }

  getBreakTypesForProfile(profileId: string) {
    const api = this.AgentConfigurationProfilesAPI.actions.getBreakTypes;
    return this.$$call(api, {}, {}, {profileId: profileId});
  }

  // ******************************
  //        Private methods
  // ******************************

  $$call(_apiCall, _params, _data, _options) {
    return this.$agentConfigurationProfiles().$call(_apiCall, _params, _data, _options);
  }
}

angular
  .module('bringoz.admin.configuration-profiles')
  .service('agentConfigurationProfilesRequestsService', AgentConfigurationProfilesRequestsService);
